import logger from '#utils/logger';

function fallbackCopyTextToClipboard(text: string) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let presponse;

  try {
    const successful = document.execCommand('copy');
    if (!successful) {
      logger.error('Fallback: Oops, unable to copy');
      presponse = Promise.reject('Unable to copy');
    } else {
      presponse = Promise.resolve('Copied');
    }
  } catch (err) {
    logger.error('Fallback: Oops, unable to copy', err);
    presponse = Promise.reject('Unable to copy');
  }

  document.body.removeChild(textArea);
  return presponse;
}

export default function copyTextToClipboard(text: string) {
  if (!navigator.clipboard) {
    return fallbackCopyTextToClipboard(text);
  }

  return navigator.clipboard.writeText(text).then(
    () => {
      if (process && process.env.APP_ENV !== 'prod') {
        logger.info('Async: Copying to clipboard was successful!');
      }
    },
    (err) => {
      logger.error('Async: Could not copy text: ', err);
    }
  );
}
